import commonUtil from '../../utils/commonUtil';

export const NOTIFICACIONS_LOAD = 'NOTIFICACIONS_LOAD';
export const NOTIFICACIONS_SUCCESS = 'NOTIFICACIONS_SUCCESS';
export const NOTIFICACIONS_FAIL = 'NOTIFICACIONS_FAIL';

export const UPDATE_NOTIFICACIONS_LOAD = 'UPDATE_NOTIFICACIONS_LOAD';
export const UPDATE_NOTIFICACIONS_SUCCESS = 'UPDATE_NOTIFICACIONS_SUCCESS';
export const UPDATE_NOTIFICACIONS_FAIL = 'UPDATE_NOTIFICACIONS_FAIL';

export const COUNT_NOTIFICACIONS_LOAD = 'COUNT_NOTIFICACIONS_LOAD';
export const COUNT_NOTIFICACIONS_SUCCESS = 'COUNT_NOTIFICACIONS_SUCCESS';
export const COUNT_NOTIFICACIONS_FAIL = 'COUNT_NOTIFICACIONS_FAIL';


export const NOTIFICACIONS_DEFAULT_IMAGE_LOAD = 'NOTIFICACIONS_DEFAULT_IMAGE_LOAD';
export const NOTIFICACIONS_DEFAULT_IMAGE_SUCCESS = 'NOTIFICACIONS_DEFAULT_IMAGE_SUCCESS';
export const NOTIFICACIONS_DEFAULT_IMAGE_FAIL = 'NOTIFICACIONS_DEFAULT_IMAGE_FAIL';



export function isNotificationLoaded(globalState) {
  return globalState.notifications && globalState.notifications.loaded;
}

export function loadNotificationsDetail(eventId, profileId, isClicked) {
  const _notificacions = {};
  _notificacions.brand = commonUtil.getBrand();
  _notificacions.channel = commonUtil.getChannel();
  _notificacions.eventId = eventId;
  //_notificacions.profileId = profileId;
  _notificacions.isClicked = isClicked || false;
  return {
    types: [NOTIFICACIONS_LOAD, NOTIFICACIONS_SUCCESS, NOTIFICACIONS_FAIL],
    promise: client => client.post('api/notification/getNotifications', {
      data: (_notificacions),
    }),
  };
}

export function getNotificationsDefaultImage() {
  const _notificacions = {};
  _notificacions.brand = commonUtil.getBrand();
  _notificacions.channel = commonUtil.getChannel();

  return {
    types: [NOTIFICACIONS_DEFAULT_IMAGE_LOAD, NOTIFICACIONS_DEFAULT_IMAGE_SUCCESS, NOTIFICACIONS_DEFAULT_IMAGE_FAIL],
    promise: client => client.get('api/notification/defaultImage'),
  };
}

export function updateNotificationsDetail(NotificationId, profileId) {
  const _notificacions = {};
  _notificacions.notificationId = NotificationId;
  _notificacions.brand = commonUtil.getBrand();
  _notificacions.channel = commonUtil.getChannel();
//  _notificacions.profileId = profileId;
  return {
    types: [UPDATE_NOTIFICACIONS_LOAD, UPDATE_NOTIFICACIONS_SUCCESS, UPDATE_NOTIFICACIONS_FAIL],
    promise: client => client.post('api/notification/updateNotificationViewStatus', {
      data: (_notificacions),
    }),
  };
}

export function countNotification(eventId, profileId, isClicked) {
  const _notificacions = {};
  _notificacions.eventId = eventId;
  _notificacions.profileId = profileId;
  _notificacions.isClicked = isClicked;
  return {
    types: [COUNT_NOTIFICACIONS_LOAD, COUNT_NOTIFICACIONS_SUCCESS, COUNT_NOTIFICACIONS_FAIL],
    promise: client => client.post('api/notification/getNotificationCount', {
      data: (_notificacions),
    }),
  };
}
